module.exports = __webpack_public_path__ + "static/media/Renewal&Modification@2x.e3a738ba.jpg";